 

  $('.product-main-image').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<div class="slick-prev slick-arrow"><svg width="30" height="30" viewBox="0 0 26 45" fill="none" xmlns="https://static.barilliance.com/img/common/prev.svg"><path d="M24.8182 44L0 22.4995L25 1" stroke="#231F20" stroke-width="1.2"></path></svg></div>',
        nextArrow: '<div class="slick-next slick-arrow"><svg width="30" height="30" viewBox="0 0 26 45" fill="none" xmlns="https://static.barilliance.com/img/common/next.svg"><path d="M1.18084 1L26 22.4995L1 44" stroke="#231F20" stroke-width="1.2"></path></svg></div>',
        fade: false,        
        asNavFor: '.product-thumb',
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
              }
            }   
          ]
    });
    $('.product-thumb').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.product-main-image',
        dots: false,        
        focusOnSelect: true,
        vertical:true,
        prevArrow: '<div class="slick-prev slick-arrow"><svg width="30" height="30" viewBox="0 0 26 45" fill="none" xmlns="https://static.barilliance.com/img/common/prev.svg"><path d="M24.8182 44L0 22.4995L25 1" stroke="#231F20" stroke-width="1.2"></path></svg></div>',
        nextArrow: '<div class="slick-next slick-arrow"><svg width="30" height="30" viewBox="0 0 26 45" fill="none" xmlns="https://static.barilliance.com/img/common/next.svg"><path d="M1.18084 1L26 22.4995L1 44" stroke="#231F20" stroke-width="1.2"></path></svg></div>',
        responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
              }
            }   
          ]
    });   
$('.product-thumb .slick-slide').removeClass('slick-active');
 $('.product-thumb .slick-slide').eq(0).addClass('slick-active');
 $('.product-main-image').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
     var mySlideNumber = nextSlide;
     $('.product-thumb .slick-slide').removeClass('slick-active');
     $('.product-thumb .slick-slide').eq(mySlideNumber).addClass('slick-active');
 });
 $('label.Color-swatch').click(function() {
   var color_size = $('.product-form__input input[type=radio]:checked+label.Color-swatch').attr('color-size');
   $('.product-thumb').slick('slickUnfilter');
   $('.product-main-image').slick('slickUnfilter');
     var color = $(this).attr('data-value');
    // alert(color);
     var color_calss = '.color_' + color;
// alert(color_calss);
   if(color_size > 1){
      $('.product-thumb .slick-slide').removeClass('slick-active');
 $('.product-thumb .slick-slide').eq(0).addClass('slick-active');
       $(".product-thumb").slick('slickFilter', color_calss);
       $('.product-thumb').slick('resize');
       $(".product-main-image").slick('slickFilter', color_calss);
       $('.product-main-image').slick('resize');
  
     $(".product-thumb .slick-slide:not(.slick-cloned)").each(function (index, slide) {
    $(slide).attr("data-slick-index", index);
});
     $(".product-main-image .slick-slide:not(.slick-cloned)").each(function (index, slide) {
    $(slide).attr("data-slick-index", index);
});
   }
 });  
$(document).ready(function() {
    var color = $('.product-form__input input[type=radio]:checked+label.enable-filter.Color-swatch').attr('data-value');
    var color_size = $('.product-form__input input[type=radio]:checked+label.Color-swatch').attr('color-size');
    var color_calss = '.color_' + color;
    // alert(color_size);
    if(color_size > 1){
    $('.product-thumb').slick('slickUnfilter');
    $('.product-main-image').slick('slickUnfilter');
    $(".product-thumb").slick('slickFilter', color_calss);
    $('.product-thumb').slick('resize');
    $(".product-thumb .slick-slide:not(.slick-cloned)").each(function (index, slide) {
    $(slide).attr("data-slick-index", index);
    });
    $(".product-main-image").slick('slickFilter', color_calss);
    $('.product-main-image').slick('resize');
    $(".product-main-image .slick-slide:not(.slick-cloned)").each(function (index, slide) {
    $(slide).attr("data-slick-index", index);
    });
}
});